var empty = true,
    jcrop_api,
    jacrop_settings = {},
    bgc = {White: "white", Black: "black"},
    thumb,
    pieces = 1,
    ratio_value,
    ratio,
    allowedWidth,
    allowedHeight,
    effects,
    form_array = [0, 0, 0, 0],
    route_set_gallery_frame_color, route_set_gallery_frame_paper,
    route_set_gallery_frame_glass, route_set_params,
    thumb_url, route_set_mount, route_set_sizes, route_set_edge, route_set_product,
    route_set_image, route_remove_image,
    body, frame_show = false, frame_size = 0,
    constructorCurrentImage = {},
    //isUpdateCropbox = true,
    isDiamond = false,
    readyForBasket = false;
var local_uploading = {}, thumbId,
    thumbUuid, // uuid of the current image - which is stored only locally - upload is in progress;
    thumbSizeXY = [535, 535]; // can be overrided for specific product
function enableHandlers() {
  var c = $(".image-controls");

  c.find(".landscape").click(setRatioHandler("Landscape"));
  c.find(".portrait").click(setRatioHandler("Portrait"));
  c.find(".diamond").click(setRatioHandler("Diamond"));
  c.find(".contour-one").click(setoptHandler("bgColor", bgc.White));
  c.find(".contour-two").click(setoptHandler("bgColor", bgc.Black));
  c.find(".rotate-left").click(setDegree(-90));
  c.find(".rotate-right").click(setDegree(90));
  $("#constructor-form").ajaxForm({async: true, dataType: "json", success: function (a) {
    var $form = $("#constructor-form"),
        behavior = $form.data('behavior');

    $("#loading").hide();

    if (behavior == 'basket') {
      $("#constructor-submit2").show();
    } else if (behavior == 'upload') {
      $("#constructor-submit3").show();
    } else {
      $("#constructor-submit").show();
    }

    if (a.result == "ok") {
      $(".basket-container p").find("strong").text("(" +
        a.cnt + ")");
      $(".pagescroll-image").each(function () {
        var b = $(this).find("img");
        if (b.attr("alt") == a.id)if ($(this).find(".basket-image").length == 0)$('<span class="basket-image"></span>').insertAfter(b)
      });
      $("#dialog").html(a.html).dialog({resizable: false, modal: true, overlay: {opacity: 1, background: "#000000"}, width: "400", open: function () {
      }});
      updateProductCounterValue(getProductCounterValue() + 1);
      if (behavior == 'basket') {
        location.href = route_basket;

        $form.data('behavior', '');
      } else if (behavior == 'upload') {
        $("#dialog").dialog('close');
        configurator.removeImage($('.pagescroll-images-container .image-line img').first());

        $form.data('behavior', '');
      }
    }
  }});
  var bubbleWaitTimeout;
  $("#constructor-submit").click(function () {
    if ((thumbUuid) && !(local_uploading[thumbUuid].status & 2)) { // file is still uploading
      if (bubbleWaitTimeout) clearTimeout(bubbleWaitTimeout);
      $("#wait-image-bubble").fadeIn();
      bubbleWaitTimeout = setTimeout(function () {$("#wait-image-bubble").fadeOut();}, 2000);
    } else if (!readyForBasket) {
      showMessageBox(waitBasketText);
    } else {
      var a = $("#loading");
      $(this).hide().after(a);
      a.show();
      $("#constructor-form").submit()
    }
  });
  $('#constructor-submit2').click(function (e) {
    e.preventDefault();

    if (!readyForBasket) {
      showMessageBox(waitBasketText);
    } else {
      var a = $("#loading");
      $(this).hide().after(a);
      a.show();
      $("#constructor-form")
        .data('behavior', 'basket')
        .submit();
    }
  });
  $('#constructor-submit3').click(function (e) {
    e.preventDefault();

    if (!readyForBasket) {
      showMessageBox(waitBasketText);
    } else {
      var a = $("#loading");
      $(this).hide().after(a);
      a.show();
      $("#constructor-form")
        .data('behavior', 'upload')
        .submit();
    }
  });
  $('#constructor-submit4').click(function (e) {
    if (!readyForBasket) {
      showMessageBox(waitBasketText);
      return false;
    }

    var $this = $(this);
    var a = $("#loading");

    customDialog('Sie können jetzt weitere Bilder gestalten oder zur Kasse gehen.', 'Ihr Bild wurde in den Warenkorb gelegt.', [{
      title: 'Neues Produkt',
      'class': 'strong-blue-button',
      action: function() {
        $this.hide().after(a);
        a.show();
        $("#constructor-form")
          .data('behavior', 'upload')
          .submit();
      }
    }, {
      title: 'Zur Kasse gehen',
      action: function() {
        $this.hide().after(a);
        a.show();
        $("#constructor-form")
          .data('behavior', 'basket')
          .submit();
      }
    }]);
  });
  $('#constructor-new-photo').click(function (e) {
    e.preventDefault();

    $("#dialog")
      .html(deleteDialogText)
      .dialog({
        resizable: false,
        modal: true,
        overlay: {opacity: 1, background: "#000000"},
        width: "400"
      });
  });
  $("#dialog").on('click', '.js-delete-photo', function (e) {
    e.preventDefault();
    e.stopPropagation();

    $("#dialog").dialog('close');
    configurator.removeImage($('.pagescroll-images-container .image-line img').first());
  })

}
function constructorUpdateMenu(data, menuImage) {
  var b = $("#const-effects")

  if (thumbUuid) { // local image
    $.each(b.find("li div.inner-element img"), function () {
      $(this).attr("src", $(this).data('src'));
    });
  } else {
    $.each(b.find("li div.inner-element"), function () {
      var f = $(this).data("effect");
      $(this).find("img.border-image").attr("src", data.pattern.replace("%effect%", f));
      $(this).find("img.border-image").attr("src", data.pattern.replace("%effect%", f))
    });
    menuImage.attr('src', thumb_url + thumb/*$('#cropbox').attr('src')*/);

    if (data.source && data.source == 'fotolia') {
      $('.photo-editor-button').hide();
    } else {
      showAviaryButton();
    }
  }
  if (data.productRating) {
    $.each(data.productRating, function(k,v) {$('#size-' + k + ' .rating-small').removeAttr('class').attr('class', 'rating-small rating-' + v);});
  }
}
function constructorUpdateOrientationMenu() {
  if (window.ratio_value == 1) {
    $(".image-controls")
      .find('.portrait').hide().end()
      .find('.diamond').show();
  } else {
    $(".image-controls")
      .find('.portrait').show().end()
      .find('.diamond').hide();
  }
}
function constructorShowMyProduct(d) {
  if (d.new_size !== undefined) {
    $("#new-size").html(d.new_size);
    $("#size-details").html(d.size);
    $("#order-size-title").html(d.new_size);
    $("#size-price").html(d.price);
    $("#total-price").html(d.sum);
    if (d.additional !== undefined && d.additional.length > 0) {
      var f = $("#constructor-menu");
      f.children(":gt(1)").remove();
      for (var e in d.additional)f.children(":last").after(d.additional[e])
    }
  } else {
    $("#new-size").html(d.size);
    //$("#size-details").html(d.size);
    $("#order-size-title").html(d.size);
    $("#size-price").html(d.price);
    $("#total-price").html(d.sum);
  }
}
// r - rotate angle
function constructorGetThumbUrl(r, addRandom, absolute) {
  var t = (new Date).getTime();
  if (typeof addRandom === 'undefined') addRandom = true;
  if (typeof absolute === 'undefined') absolute = false;
  return (absolute ? aviary.config._imgUrl : window.thumb_url ) +
    r + "_original" + "_" + window.thumb + (addRandom ? "?" + t : "");
}
function constructorShowImageQuality(html) {
  var tooltip = $(".image-controls .image-quality .action-tooltip").html();
  $(".image-controls .image-quality").html(html + '<span class="action-tooltip">' + tooltip + '</span>');
}
function getMaxThumbLimit() {
  return {tw: Math.min(screen.availWidth-300, 800), th: Math.min(screen.availHeight-200, 600)};
}
function constructorComputeThumbSize(response, resetCropbox) {
  if (response && response.ratio) {
    if (response.ratio != ratio) {
      configurator.changeOrientation(response.ratio);
    }
  }

  // compute image size
  var img = $('#cropbox')[0];
  var imgSZ = configurator._computeThumbSize(img.naturalWidth, img.naturalHeight);
  var imgW = imgSZ[0],
    imgH = imgSZ[1];
  if (configurator.options.adjustComputedImageSize) {
    $("#cropbox").css({width: imgW + 'px', height: imgH + 'px'}).attr('width', imgW).attr('height', imgH);
  } else {
    imgSZ = [img.width, img.height]; imgW = imgSZ[0]; imgH = imgSZ[1];
  }

  var sizes = {
      x1: $("#constructor_x1").val(),
      y1: $("#constructor_y1").val(),
      x2: $("#constructor_x2").val(),
      y2: $("#constructor_y2").val(),
      w: $("#constructor_w").val(),
      h: $("#constructor_h").val(),
      szx: imgW,
      szy: imgH
  };//conlog(sizes['x1']);conlog($("#constructor_x1").val());
  var cropIsOut = sizes.x1 > img.naturalWidth || sizes.y1 > img.naturalHeight;
conlog(resetCropbox);
conlog(isUpdateCropbox);
conlog(cropIsOut);
  if (resetCropbox !== 'undefined' && resetCropbox || isUpdateCropbox || cropIsOut) {
    isUpdateCropbox = false;
    // compute cropbox restrictions

    /*if (sizes.x1 < 0 || cropIsOut)*/ sizes.x1 = 0;
    /*if (sizes.y1 < 0 || cropIsOut)*/ sizes.y1 = 0;
    //if (sizes.x2 > imgW - 1) sizes.x2 = imgW - 1;
    //if (sizes.y2 > imgH - 1) sizes.y2 = imgH - 1;
    sizes.x2 = img.naturalWidth;
    sizes.y2 = img.naturalHeight;

    if (isDiamond) {
      if (imgW >= imgH) {
        sizes.x2 = sizes.x1 = imgW / 2;
        sizes.y1 = 0;
        sizes.y2 = imgH;
      } else {
        sizes.y2 = sizes.y1 = imgH / 2;
        sizes.x1 = 0;
        sizes.x2 = imgW;
      }
    }

    configurator.basket.setImageCrop(sizes);
  }
  conlog($("#constructor_x1").val());
}
function initJcrop() {
  if (window.jcrop_api !== undefined) {
    jcrop_api.destroy();
  }
  var e = 0, f = (pieces > 1 ? pieces - 1 : 0);
  var tw = constructorCurrentImage.thumbWidth,
    th = constructorCurrentImage.thumbHeight;
  if (ratio == "Portrait") {
    e = [f, f = e][0];
  }
  if (constructorCurrentImage.degree % 180) {
    tw = [th, th = tw][0];
  }
  frame_show = false;
  var p = $('#const-products').find('.active-inner a').data('slug');
  if (p === 'acryl-glass' || p === 'alu-dibond-acryl-glass' || p === 'alu-dibond' || p === 'forex') {
    frame_show = true;
    frame_size = $('#const-sizes').find('tr.active .size').data('size')
  }
  $("#cropbox").Jcrop({
      bgFade: true,
      bgColor: "white",
      bgOpacity: 0.3,
      setSelect: [$("#constructor_x1").val(), $("#constructor_y1").val(), $("#constructor_x2").val(), $("#constructor_y2").val()],
      allowSelect: 0,
      minSize: [allowedWidth, allowedHeight],
      aspectRatio: ratio_value,
      rotation: isDiamond ? 45 : 0,
      onChange: changeCoords,
      onSelect: changeCoords,
      xLinesCount: e,
      yLinesCount: f,
      trueSize: [tw, th]
    }, function () {
      jcrop_api = this
  });
}
function showFrame() {
  if (frame_show) {
    var i = $('#constructor-image'),
      w = i.find('.jcrop-tracker').width(),
      b = Math.round(w/frame_size/2),
      d = i.find('.jcrop-dragbar');
    if (!d.hasClass('frame')) {
      d.addClass('frame');
    }
    i.find('.jcrop-dragbar.ord-e, .jcrop-dragbar.ord-w').css('width', b + 'px');
    i.find('.jcrop-dragbar.ord-n, .jcrop-dragbar.ord-s').css('height', b + 'px');
  }
}
function changeCoords(b) {
  if (b.w == 0 || b.h == 0) {
    jcrop_api !== undefined && jcrop_api.setSelect(form_array);
  } else {
    $("#constructor_x1").val(Math.round(b.x));
    $("#constructor_y1").val(Math.round(b.y));
    $("#constructor_x2").val(Math.round(b.x2));
    $("#constructor_y2").val(Math.round(b.y2));
    $("#constructor_w").val(Math.round(b.w));
    $("#constructor_h").val(Math.round(b.h))
  }
  showFrame()
}
function setoptHandler(c, d) {
  return function () {
    var a = {};
    a[c] = d;
    jcrop_api.setOptions(a);
    return false
  }
}
function setRatioHandler(b) {
  return function () {
    var o = b;
    isDiamond = b == 'Diamond';
    if (isDiamond) {
      o = 'Landscape';
    };
    $("#constructor_r").val(0 + isDiamond);
    configurator.changeOrientation(o);
    isUpdateCropbox = true;
    configurator.showImage();
    return false
  }
}
function setDegree(b) {
  return function () {
    readyForBasket = false;
    var d = $("#constructor_d"), g = 0, w, h;
    if (b == "90" || b == "-90") {
      g = parseInt(d.val()) + parseInt(b);
      if (g < 0)g += 360;
      if (g >= 360)g -= 360
    }
    d.val(g);
    $.post(route_set_params, {d: g});
    constructorCurrentImage.degree = g;

    if (Math.abs(b % 180)) {
      configurator.changeOrientation(ratio == 'Portrait' ? 'Landscape' : 'Portrait');
    }
    isUpdateCropbox = true;
    configurator.showImage();

    return false
  }
}
function updateJcrop(){
  $(this).off('load', updateJcrop);
  constructorComputeThumbSize();
  initJcrop()
}
function updateProduct(j) {

}
function updateImageCounterValue(b) {
  $("#basket-image-counter-value").text(b)
}
function getImageCounterValue() {
  var b = parseInt($("#basket-image-counter-value").text());
  return isNaN(b) ? 0 : b
}
function guid() {
  return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function(c) {var r = Math.random()*16|0,v=c=='x'?r:r&0x3|0x8;return v.toString(16);});
}
$(document).ready(function () {
  body = $("body");
  if (!empty) {
    enableHandlers();
    if ($("#product-title").text() == "Alu Dibond" || ($("#product-title").text() == "Alu Dibond + Acryl-Glas" || ($("#product-title").text() == "Forex" || $("#product-title").text() == "Acryl-Glas")))$("#frame_warning").show(); else $("#frame_warning").hide()
  }
  body.delegate(".constructor-menu-header", "click", function () {
    var b = !$(this).closest("li").hasClass("active");
    $(this).closest("ul.constructor-menu").find("li").removeClass("active");
    if (b)$(this).closest("li").addClass("active")
  });
  body.delegate(".constructor-menu-close", "click", function () {
    $(this).closest("li").removeClass("active")
  });
  body.delegate(".mount-links", "click", function (b) {
    b.preventDefault();
    $("#const-mount").find("li").removeClass("active-inner");
    $(this).parent().addClass("active-inner");
    $.post(route_set_mount, {mount: $(this).data("value")}, function (a) {
        if (a.result == "ok") {
          $("#new-size").html(a.new_size);
          $("#size-details").html(a.size);
          $("#order-product-mount").html(a.mount);
          $("#size-price").html(a.price);
          $("#total-price").html(a.sum)
        }
        $("#constructor-menu").find(".active .constructor-menu-close").trigger("click")
      },
      "json")
  });
  body.delegate(".new-mount-links", "click", function (b) {
    b.preventDefault();
    $("#const-new-mount, #const-new-mount2").find("li").removeClass("active-inner");
    $(this).parent().addClass("active-inner");
    var wasMount = constructorCurrentImage.mount;
    $.post(route_set_mount, {mount: $(this).data("value")}, function (a) {
      if (a.result == "ok") {
        if (a.no)$("#order-product-mount").parents("li").show(); else $("#order-product-mount").parents("li").hide();
        $("#new-size").html(a.new_size);
        $("#size-details").html(a.size);
        $("#order-product-new-mount").html(a.mount);
        $("#size-price").html(a.price);
        $("#total-price").html(a.sum);
        // TODO reinitialize constructor object without reloading
        /*if (wasMount != a.mountId) {
          location.reload();
        }*/
      }
      $("#constructor-menu").find(".active .constructor-menu-close").trigger("click")
    }, "json")
  });
  /*body.delegate(".product-links", "click", function (b) {

  });
  body.delegate(".border-links", "click", function (b) {

  });
  body.delegate(".size-links", "click", function () {

  });*/
  body.delegate(".edge-links", "click", function (b) {
    b.preventDefault();
    if (!empty) {
      $("#const-edges").find("li").removeClass("active-inner");
      $(this).parent().addClass("active-inner");
      $.post(route_set_edge, {edge: $(this).data("value")}, function (a) {
        if (a.new_size != "")$("#new-size").html(a.new_size);
        if (a.size != "")$("#size-details").html(a.size);
        if (a.edge != "")$("#order-product-edge").html(a.edge);
        $("#constructor-menu").find(".active .constructor-menu-close").trigger("click")
      }, "json")
    } else $("#constructor-menu").find(".active .constructor-menu-close").trigger("click")
  });
  body.delegate(".gallery-frame-color-links", "click", function (b) {
    b.preventDefault();
    if (!empty) {
      $("#const-gallery-frame-colors").find("li").removeClass("active-inner");
      $(this).parent().addClass("active-inner");
      // Update constructor background
      /*$('.constructor-image-container').css('background-image', 'url("/images/frame-' + $(this).data('name') + '.jpg")');*/
      $.post(route_set_gallery_frame_color, {id: $(this).data("value")}, function (a) {
        if (a.details != "")$("#size-details").html(a.details);
        if (a.title != "")$("#order-gallery-frame-color-title").html(a.title);
        $("#constructor-menu").find(".active .constructor-menu-close").trigger("click")
      }, "json");
      configurator.setRahmenName($(this).data('name'));
      configurator.showImage();
    } else $("#constructor-menu").find(".active .constructor-menu-close").trigger("click")
  });
  body.delegate(".gallery-frame-paper-links", "click", function (b) {
    b.preventDefault();
    if (!empty) {
      $("#const-gallery-frame-papers").find("li").removeClass("active-inner");
      $(this).parent().addClass("active-inner");
      $.post(route_set_gallery_frame_paper, {id: $(this).data("value")}, function (a) {
        if (a.details != "")$("#size-details").html(a.details);
        if (a.title != "")$("#order-gallery-frame-paper-title").html(a.title);
        $("#constructor-menu").find(".active .constructor-menu-close").trigger("click")
      }, "json")
    } else $("#constructor-menu").find(".active .constructor-menu-close").trigger("click")
  });
  body.delegate(".gallery-frame-glass-links", "click", function (b) {
    b.preventDefault();
    if (!empty) {
      $("#const-gallery-frame-glasses").find("li").removeClass("active-inner");
      $(this).parent().addClass("active-inner");
      $.post(route_set_gallery_frame_glass, {id: $(this).data("value")}, function (a) {
        if (a.details != "")$("#size-details").html(a.details);
        if (a.title != "")$("#order-gallery-frame-glass-title").html(a.title);
        $("#constructor-menu").find(".active .constructor-menu-close").trigger("click")
      }, "json")
    } else $("#constructor-menu").find(".active .constructor-menu-close").trigger("click")
  })
});
function showAviaryButton() {
  if (megapixels <= 25) {
    $('.photo-editor-button').show();
  } else {
    $('.photo-editor-button').hide();
  }
}
function MountFrame() {
  var self = this,
    container, target;
  self.config = {}; // default config is in the bottom

  self.init = function(cfg) {
    self.config = $.extend({}, self.defaultConfig, cfg);
    container = $(self.config.container).css({position: 'relative'});
    target = container.find(self.config.target);
    self.hide();
    if (self.config.productSize instanceof Array) {
      self.config.productSize[0] = parseFloat(self.config.productSize[0]);
      self.config.productSize[1] = parseFloat(self.config.productSize[1]);
    }
  };

  self.show = function() {
    if (self.config.matSize) {
      self.showWithFrame();
      return;
    }

    self.hide();
    container.css({margin: self.config.borderWidth+'px auto'});
    var img = container.find('img').first(),
        to = target.offset(), co = container.offset();
    var width = img.width(), height = img.height(),
        left = to.left - co.left, top = to.top - co.top,
        imw = self.config.itemWidth - self.config.itemMargin,
        imh = self.config.itemHeight - self.config.itemMargin;
    var offsetLeft = left - imw, offsetTop = top - imh,
        offsetRight = left + width - self.config.itemMargin, offsetBottom = top + height - self.config.itemMargin;
    var horizWidth = width/*-self.config.itemMargin*2*/, vertHeight = height/*-self.config.itemMargin*2*/;
    var div = $('<div class="'+self.config.itemClass+'" style="width: '+self.config.itemWidth+'px; height: '+self.config.itemHeight+'px;position:absolute;">');
    var i = new Array(10);
    i[2] = div.clone().css({background: 'url('+self.config.horizontalImage+') repeat-x transparent', left: (offsetLeft+self.config.itemWidth-self.config.itemMargin)+'px', width: horizWidth+'px'});
    i[8] = i[2].clone().css({'background-position': '0 -'+self.config.itemHeight+'px', top: offsetTop+'px'});
    i[2].css({top: offsetBottom+'px'});
    i[6] = div.clone().css({background: 'url('+self.config.verticalImage+') repeat-y transparent', top: /*self.config.itemMargin+'px'*/0, height: vertHeight+'px'});
    i[4] = i[6].clone().css({'background-position': '-'+self.config.itemWidth+'px 0', left: offsetLeft+'px'});
    i[6].css({left: offsetRight+'px'});
    i[7] = div.clone().css({background: 'url('+self.config.cornerImage+') no-repeat transparent'});
    i[9] = i[7].clone().css({'background-position': '0 -'+self.config.itemHeight+'px', left: offsetRight+'px', top: offsetTop+'px'}),
    i[1] = i[7].clone().css({'background-position': '-'+self.config.itemWidth+'px 0', left: offsetLeft+'px', top: offsetBottom+'px'}),
    i[3] = i[7].clone().css({'background-position': '0 0', left: offsetRight+'px', top: offsetBottom+'px'});
    i[7].css({'background-position': '-'+self.config.itemWidth+'px -'+self.config.itemHeight+'px', left: offsetLeft+'px', top: offsetTop+'px'});
    for (var j = 0; j < i.length; j++) {
      if (i[j]) j%2 ? target.before(i[j]) : container.prepend(i[j]);
    }
    //console.log(i);
  };

  self.showWithFrame = function() {
    self.hide();
    container.css({margin: self.config.borderWidth+'px auto'});
    var img = container.find('img').first();
    var width = img.width(), height = img.height(),
      imw = self.config.itemWidth - self.config.itemMargin,
      imh = self.config.itemHeight - self.config.itemMargin;

    // determine largest side
    var frameWidthCm = self.config.productSize[0] + self.config.matSize[1] + self.config.matSize[3],
        frameHeightCm = self.config.productSize[1] + self.config.matSize[0] + self.config.matSize[2],
        frameRatio = frameWidthCm / frameHeightCm,
        frameInnerRatio = self.config.innerWidthMax / self.config.innerHeightMax;
    if (frameInnerRatio < frameRatio) { // width is the base, height will be decreased
      frameWidth = self.config.innerWidthMax;
      frameHeight = Math.round(frameWidth / frameRatio);//Math.round(frameWidth/frameWidthCm * frameHeightCm);
    } else {
      frameHeight = self.config.innerHeightMax;
      frameWidth = Math.round(frameHeight * frameRatio);//Math.round(frameHeight / frameHeightCm * frameWidthCm);
    }
    var matSize = [
      Math.round(self.config.matSize[0] * frameHeight / frameHeightCm),
      Math.round(self.config.matSize[1] * frameWidth / frameWidthCm),
      Math.round(self.config.matSize[2] * frameHeight / frameHeightCm),
      Math.round(self.config.matSize[3] * frameWidth / frameWidthCm)
    ];
    var imgSize = [
      frameWidth - matSize[1] - matSize[3],
      frameHeight - matSize[0] - matSize[2]
    ];

    target.css({
      padding: matSize[0] + 'px ' + matSize[1] + 'px ' + matSize[2] + 'px ' + matSize[3] + 'px'
    });
    img.css({
      'max-width': 'none',
      'max-height': 'none',
      width: imgSize[0] + 'px',
      height: imgSize[1] + 'px',
      border: '2px inset #eee'
    });

    var to = target.offset(), co = container.offset();
    var left = to.left - co.left, top = to.top - co.top;
    var offsetLeft = left - imw, offsetTop = top - imh,
        offsetRight = left + frameWidth - self.config.itemMargin, offsetBottom = top + frameHeight - self.config.itemMargin;
    var horizWidth = frameWidth/*-self.config.itemMargin*2*/, vertHeight = frameHeight/*-self.config.itemMargin*2*/;
    var div = $('<div class="'+self.config.itemClass+'" style="width: '+self.config.itemWidth+'px; height: '+self.config.itemHeight+'px;position:absolute;">');
    var i = new Array(10);
    i[2] = div.clone().css({background: 'url('+self.config.horizontalImage+') repeat-x transparent', left: (offsetLeft+self.config.itemWidth-self.config.itemMargin)+'px', width: horizWidth+'px'});
    i[8] = i[2].clone().css({'background-position': '0 -'+self.config.itemHeight+'px', top: offsetTop+'px'});
    i[2].css({top: offsetBottom+'px'});
    i[6] = div.clone().css({background: 'url('+self.config.verticalImage+') repeat-y transparent', top: /*self.config.itemMargin+'px'*/0, height: vertHeight+'px'});
    i[4] = i[6].clone().css({'background-position': '-'+self.config.itemWidth+'px 0', left: offsetLeft+'px'});
    i[6].css({left: offsetRight+'px'});
    i[7] = div.clone().css({background: 'url('+self.config.cornerImage+') no-repeat transparent'});
    i[9] = i[7].clone().css({'background-position': '0 -'+self.config.itemHeight+'px', left: offsetRight+'px', top: offsetTop+'px'}),
      i[1] = i[7].clone().css({'background-position': '-'+self.config.itemWidth+'px 0', left: offsetLeft+'px', top: offsetBottom+'px'}),
      i[3] = i[7].clone().css({'background-position': '0 0', left: offsetRight+'px', top: offsetBottom+'px'});
    i[7].css({'background-position': '-'+self.config.itemWidth+'px -'+self.config.itemHeight+'px', left: offsetLeft+'px', top: offsetTop+'px'});
    for (var j = 0; j < i.length; j++) {
      if (i[j]) j%2 ? target.before(i[j]) : container.prepend(i[j]);
    }

    //console.log(i);
  };

  self.hide = function() {
    container.find('.'+self.config.itemClass).remove();
    target.css({padding: 0});
  };

  // default configuration
  self.defaultConfig = {
    container: '.constructor-image-container',
    target: '#constructor-image',
    cornerImage: '',
    horizontalImage: '',
    verticalImage: '',
    innerWidthMax: 535,               // Maximum width of the frame content
    innerHeightMax: 535,              // Maximum height of the frame content
    itemWidth: 200,                   // frame width
    itemHeight: 200,                  // frame height
    itemClass: 'mount-frame-item',
    itemMargin: 50,                   // offset of every corner to the image center
    borderWidth: 60,
    //
    matSize: null,                    // indentation from image to border [top, right, bottom, left], in centimeters
    matColor: '#FFFFFF',              // TODO
    productSize: null,                // picture size [width, height] in centimeters
  };
}
function AviaryConnector() {
  var self = this;
  var feather;
  self.config = {}; // default config is in the bottom
  self.init = function (cfg) {
    if ($.isEmptyObject(self.config)) self.config = $.extend({}, self.defaultConfig, cfg);
    else self.config = $.extend({}, self.config, cfg); // allow to repeat initialization with the similar options
    $(self.config._buttonSelector)
      .off('click')
      .click(self.launch);
  };
  self.launch = function launchEditor() {
    if ($(self.config._buttonSelector).hasClass('loading')) {
      return false;
    }
    $(self.config._buttonSelector).addClass('loading');

    if (feather) {
      self._launch();
    } else {
      $('<div id="injection_site"></div>').appendTo('body');
      var options = self.config,
          scriptUrl = 'https:' == document.location.protocol ? self.config._scriptUriSsl : self.config._scriptUri;
      options.onLoad = self._launch;

      $.ajax({
        url: scriptUrl,
        dataType: 'script',
        cache: true,
        success: function() {
          feather = new Aviary.Feather(options);
        },
        error: function() {
          $(self.config._buttonSelector).removeClass('loading');
        }
      });
    }
  };
  self._launch = function() {
    var id = $(this).data('image-id'),
        src = $('#cropbox').attr('src');
    if (!id) {
      id = thumbId;
    }
    if (src.indexOf('http') !== 0 && src.indexOf('data') !== 0) {
      src = self.config._baseUrl + src;
    }

    var srcImageUrl = self.config._imgUrl + thumb.replace('thumb_', '') + '?' + Math.random();
    self.srcImage = new Image();
    self.srcImage.onload = function() {
      self.preload(function() {
        var options = $.extend({}, self.addConfig, {
          image: self.srcImage,//'cropbox'
          //url: self.srcImage.src, // todo normal res
          hiresUrl: srcImageUrl,
          onSaveHiRes: self.onSaveHiRes
        });
        feather.launch(options);
        console.log('Loading image to aviary: ' + srcImageUrl);
      });
    }
    self.srcImage.onerror = function() {
      $(self.config._buttonSelector).removeClass('loading');
    }
    $('#cropbox-orig-thumb').remove();
    $('body').append($(self.srcImage).attr('id', 'cropbox-orig-thumb').css('display', 'none'));
    //self.srcImage.src = srcImageUrl;
    self.srcImage.src = constructorGetThumbUrl(0, true, true);
  };
  self.onSaveButtonClicked = function() {
    feather.saveHiRes();
    return false;
  };
  self.onSave = function(imageID, newURL) {
    $('<div class="loading splash"></div>').appendTo($('#constructor-image'));
    $('<div class="loading splash"></div>').appendTo($('.pagescroll-images-container img[alt="'+thumbId+'"]').closest('.pagescroll-image'));

    //console.log('onSave called');
    console.log('Receiving image from aviary: ' + newURL);

    var data = $.extend({}, {
      'id': thumbId,
      'remote_url': newURL
    }, getMaxThumbLimit());

    $.post(route_local_image, data, function (r) {
      $('.pagescroll-images-container .image-line [alt="'+ thumbId +'"]').trigger('click');
    });
    feather.close();
  };
  self.onSaveHiRes = function(domId, url) {
    console.log('onSaveHiRes called');
    self.onSave(domId, url);
  };
  self.onError = function(errorObj) {
    console.log(errorObj.message);
    console.log(errorObj);
    //alert(errorObj.message);
  };
  self.onClose = function(isDirty) {
    $(self.config._buttonSelector).removeClass('loading');
  };
  self.preload = function(callback) {
    $.post(self.config._preloadEditor, function(d) {
      self.addConfig = d;
      var options = $.extend({}, self.config, self.addConfig);
      //console.log(options);

      if (typeof callback == 'function') {
        callback.call(self, self.addConfig);
      }
    }, 'json');
  };

  // Aviary default configuration
  self.defaultConfig = {
    apiKey: '',
    apiVersion: 3,
    theme: 'light',
    language: 'de',
    fileFormat: 'jpg',
    tools: 'all',
    appendTo: '',
    //postData: '',
    //postUrl: '',
    onSave: this.onSave,
    onSaveButtonClicked: this.onSaveButtonClicked,
    onError: this.onError,
    onClose: this.onClose,
    _scriptUri: 'http://feather.aviary.com/js/feather.js',
    _scriptUriSsl: 'https://dme0ih8comzn4.cloudfront.net/js/feather.js',
    _baseUrl: '',
    _imgUrl: '',
    _imageId: 'cropbox',
    _buttonSelector: '.constructor-actions .photo-editor-button'
  };
  self.addConfig = {};
}
function conlog(message) {
  if (typeof message == 'object') {
    console.log(((new Date()).getTime() / 1000) + ':');
    console.log(message);
  } else {
    console.log(((new Date()).getTime() / 1000) + ': ' + message);
  }
}
function html5upload() {
  this.default_config = {
    max_file_size: 1048576,
    allowed_file_types: ["image/jpeg", "image/pjpeg", "image/bmp", "image/x-bmp", "image/x-bmp", "image/x-ms-bmp", "image/tiff", "image/tiff-fx"],
    max_quantity_of_files: 25,
    form_action: "",
    error_size_txt: "Error! File is too big (#VALUE#).", error_type_txt: "Error! Incorrect type of file (#VALUE#).", error_txt: "Error! Your browser doesn't support drag and drop upload. Please install modern browsers to use this feature.", success_txt: "Image was uploaded sucessfully", not_leave_txt: "The file uploading is still in progress. If you close this page uploading will be aborted. Close the page?",
    form_id: "html5form",
    file_info_selector: "html5_file_info",
    input_file_selector: "",
    dnd_selector: "",
    progressbar: false,
    max_thumb_width: 100,
    max_thumb_height: 100,
    upload_name: "",
    upload_id: ""
  };
  this.config = {};
  this.uploaded_files_cnt = 0;
  this.completed_files_cnt = 0;
  this.file_list_template = '<div class="file-list-#NR#"><div class="file-name">#NAME#</div><div class="file-size">#SIZE#</div><div class="file-type">#TYPE#</div><div class="clear"></div></div><div class="progressbar"></div>';
  this.status_local = 1;      // необработанный локальный файл
  this.status_uploaded = 2;   // полностью готовый к работе файл
  this.status_read = 4;       // прочтенный FileReader файл
  this.status_parsed = 8;     // загруженный в контейнер Image файл
  this.status_queried = 16;   // информация о локальном файле послана на сервер
  this.status_uploading = 32; // файл загружается на сервер
  var self = this;
  this.init = function (d) {
    this.config = $.extend({}, this.default_config, d);
    if (window.File && (window.FileList && window.FileReader)) {
      $("#html5upload").show();
      var c = this;
      if (this.config.input_file_selector)$("body").on("change", "#" + this.config.input_file_selector, function (a) {
        c.file_selected()
      });
      if (this.config.dnd_selector)$("body").on("dragover", "#" + this.config.dnd_selector,function (a) {
        c.file_drag_hover(a.originalEvent)
      }).on("dragleave", "#" + this.config.dnd_selector,function (a) {
        c.file_drag_hover(a.originalEvent)
      }).on("drop", "#" + this.config.dnd_selector, function (a) {
        c.file_select_handler(a.originalEvent)
      })
    } else $("#html5upload").html(this.config.error_txt).show()
  };
  this.leaveHandler = function() {
    return self.config.not_leave_txt;
  }
  this.onStartUpload = function() {
    $(window).unbind('beforeunload', self.leaveHandler);
    $(window).bind('beforeunload', self.leaveHandler);
  }
  this.onFinishUpload = function() {
    self.uploaded_files_cnt = 0;
    self.completed_files_cnt = 0;
    $("#" + self.config.file_info_selector).html("");
    //$("#" + self.config.file_info_selector).hide();
    //$("#html5upload").show();
    $(window).unbind('beforeunload', self.leaveHandler);
  }
  this.file_drag_hover = function (b) {
    b.stopPropagation();
    b.preventDefault();
    $("#" + this.config.dnd_selector).attr("class", b.type == "dragover" ? "hover" : "")
  };
  /**
   * Upload entry point
   * onFileDrop, on input:file change
   */
  this.file_select_handler = function (h) {
    var k;
    // from drag&drop
    if (h instanceof MouseEvent) {
      this.file_drag_hover(h);
      k = h.target.files || h.dataTransfer.files;

      // from html input:file
    } else if (typeof h == 'object' && h.tagName == 'INPUT') {
      k = h.files;
    }
    if (!k || !k.length) return;

    if ($("#dialog").dialog("isOpen"))$("#dialog").dialog("close");
    //$("#html5upload").hide();
    //$("#" + this.config.file_info_selector).show();
    self.onStartUpload();
    var f = $("#" + this.config.file_info_selector + " .file-name").length;
    var fcnt = k.length, fsuccess = 0;
    for (var e = 0, j; j = k[e]; e++) {
      f++;
      this.upload_file_from_dnd(j, f) && fsuccess++;
      if (e + 1 == this.config.max_quantity_of_files)break
    }
    if (this.uploaded_files_cnt == this.completed_files_cnt) {
      self.onFinishUpload();
    }
    if (!fsuccess) {
      var msg = customDialogText.split('%header%').join(invalidFileErrorHeader).split('%message%').join(invalidFileErrorText);
      $("#dialog").html(msg).dialog({resizable: false, modal: true, overlay: {opacity: 1, background: "#000000"}, width: "400", open: function () {
      }});
    }
  };
  this.parse_file = function (d, f) {
    var e = (d.size > 1024 * 1024) ?
      (Math.round(d.size * 100 / (1024 * 1024)) / 100).toString() + "MB" :
      e = (Math.round(d.size * 100 / 1024) / 100).toString() + "KB";
    $("#" + this.config.file_info_selector).append(this.file_list_template.replace("#NR#", f).replace("#NAME#", d.name).replace("#SIZE#", e).replace("#TYPE#", d.type))
  };
  this.check_file = function (h) {
    var g = false;
    for (var e in this.config.allowed_file_types)if (this.config.allowed_file_types[e] == h.type)g = true;
    if (!g)return this.config.error_type_txt.replace("%mime_type%", h.type);
    if (h.size <= this.config.max_file_size)return true;
    var f = 0;
    if (h.size > 1024 * 1024)f = (Math.round(h.size * 100 / (1024 * 1024)) / 100).toString() + "MB"; else f = (Math.round(h.size * 100 / 1024) / 100).toString() + "KB";
    return this.config.error_size_txt.replace("#VALUE#", f)
  };
  this.upload_file_from_dnd = function (e, h) {
    var f =
      this.check_file(e);
    if (f === true) {
      var uuid = guid();
      local_uploading[uuid] = {
        file: e,
        queueNum: h,
        start: new Date(),
        uuid: uuid,
        status: self.status_local,
        progressTimer: null
      };
      this.localUpload(uuid);
      return true;
    } else {
      //$("#" + this.config.file_info_selector + " .file-list-" + h).next().addClass("error").html(f)
    }
    return false;
  };
  this.file_selected = function () {
    var c = document.getElementById(this.config.input_file_selector).files[0];
    if (c) {
      var d = this.check_file(c);
      if (d === true) {
        this.upload_file();
      } else {
        $("#" + this.config.file_info_selector + " .file-list-1").next().html(d)
      }
    }
  };
  this.upload_file = function () {
    var b = new FormData(document.getElementById(this.config.form_id));
    this.make_upload(b)
  };
  this.make_upload = function (f, e, uuid) {
    self.uploaded_files_cnt++;
    var g = new XMLHttpRequest;
    var h = self;
    uuid = uuid || '';
    g.upload.addEventListener("progress", function (a) {
      h.upload_progress(a, e, uuid)
    }, false);
    g.addEventListener("load", function (a) {
      h.upload_complete(a, e, uuid);
      updateImageCounterValue(getImageCounterValue() + 1)
    }, false);
    g.addEventListener("error", function (a) {
      h.upload_failed(a, uuid)
    }, false);
    g.addEventListener("abort", function (a) {
      h.upload_canceled(a, uuid)
    }, false);
    g.async = true;
    if (self.config.upload_name) {
      g.open("POST", self.config.form_action, true, self.config.upload_name, self.config.upload_id);
    } else {
      g.open("POST", self.config.form_action, true);
    }
    g.withCredentials = true;
    g.send(f)
  };
  this.upload_progress =
    function (e, f, uuid) {
      if (e.lengthComputable) {
        var d = Math.round(e.loaded * 100 / e.total);
        if (this.config.progressbar)$("#" + this.config.file_info_selector + " .file-list-" + f).next().reportprogress(d); else $("#" + this.config.file_info_selector + " .file-list-" + f).next().html(d.toString() + "%");
        d = Math.round(e.loaded * 80 / e.total); // 20% for server operations
        //console.log('upload_progress('+uuid+','+e.loaded+'/'+e.total+')');
        if (uuid && local_uploading[uuid]) {
          var pb = $('.uploaded-images .image-line .pagescroll-image [alt="' + local_uploading[uuid]['id'] + '"]').closest('.pagescroll-image').find('.upload-progress .bar');
          var pbd = pb.data('progress') || 0;
          if (pbd < d) {
            var now = new Date(), w = pb.parent().width() * d / 100;
            var pbt = pb.data('progress-time') || now.toString();
            pb.data('progress', d.toString()).data('progress-time', now.toString())
              .stop().animate({width: w + 'px'}, {duration: now - (new Date(pbt)) || 1000});
          }
          if (d == 80/* || ($.browser.mozilla && d >= 72)*/) { // stupid firefox
            local_uploading[uuid].progressTimer = setTimeout(function() {self.simulateProgress(uuid)}, 500);
          }
        }
      } else $("#" + this.config.file_info_selector + " .file-list-" + f).next().html("unable to compute")
    };
  this.simulateProgress = function(uuid) {
    //console.log('simulateProgress('+uuid+')');
    if (local_uploading[uuid]) {
      var bar = $('.uploaded-images .image-line .pagescroll-image [alt="' + local_uploading[uuid]['id'] + '"]').closest('.pagescroll-image').find('.upload-progress .bar');
      var percent = parseInt(bar.data('progress')) + 1;
      if (percent <= 100) {
        bar.data('progress', percent.toString()).css({width: percent.toString() + '%'});
        local_uploading[uuid].progressTimer = setTimeout(function() {self.simulateProgress(uuid)}, 500);
      }
    }
  };
  this.upload_complete = function (q, m, uuid) {
    var n = $.parseJSON(q.target.responseText), l, j, o;
    if (n.status == "success") {
      $.post(route_local_image, {local_update: [{id: local_uploading[uuid]['id'], status: 'uploaded'}]});

      this.completed_files_cnt++;
      $("#" + this.config.file_info_selector + " .file-list-" + m).next().remove();
      $("#" + this.config.file_info_selector + " .file-list-" + m).remove();

      uuid = uuid || guid();
      if (!local_uploading[uuid]) {
        local_uploading[uuid] = {uuid: uuid};
      }
      $.extend(local_uploading[uuid], {
        status: local_uploading[uuid].status | self.status_uploaded,
        id: n.id,
        image: n.image,
        src: n.image.replace(/.*src=(["'])(.*?)\1.*/, '$2'),
        first: n.first || false,
        ext: n
      });

      self.presentNewFile(uuid);
    } else {
      this.completed_files_cnt++
      if (uuid) {
        if (n.errors && n.errors.picture && n.errors.picture.indexOf('mime') != -1) {
          showMessageBox(invalidFileErrorText, invalidFileErrorHeader);
        }
        self.deleteCancelledImage(uuid);
      }
      //var k = "", p;
      //for (p in n.errors)k = k + n.errors[p];
      //$("#" + this.config.file_info_selector + " .file-list-" + m).next().html(k + "<br />");
    }

    if (uuid && local_uploading[uuid]) {
      $('.uploaded-images .image-line .pagescroll-image [alt="' + local_uploading[uuid]['id'] + '"]')
        .closest('.pagescroll-image').removeClass('upload-in-progress').find('.upload-progress').remove();
    }
    if (this.completed_files_cnt == this.uploaded_files_cnt) {
      self.onFinishUpload();
    }
  };
  this.upload_failed = function (b, uuid) {
    this.completed_files_cnt++
    if (uuid) self.deleteCancelledImage(uuid);
  };
  this.upload_canceled = function (b, uuid) {
    this.completed_files_cnt++;
    if (uuid) self.deleteCancelledImage(uuid);
  };
  this.deleteCancelledImage = function (uuid) {
    if (local_uploading[uuid]) {
      $.post(route_local_image, {local_update: [{id: local_uploading[uuid]['id'], status: 'canceled'}]});

      //this.completed_files_cnt++;
      if (this.uploaded_files_cnt == this.completed_files_cnt) {
        setTimeout(self.onFinishUpload, 2000);
      }

      self.removeImageIconFromMenu(null, uuid, true);
    }

  };
  this.transferLocalUpload = function(uuid) {
    var upload = [local_uploading[uuid]];
    $.each(/*local_uploading*/upload, function (k, v) {
      if (!(v.status & self.status_uploading)) {
        v.status |= self.status_uploading;
        var g = new FormData;
        g.append("picture", v.file);
        g.append("id", v.id);
        self.uploaded_files_cnt--;
        try {
          self.make_upload(g, v.queueNum, v.uuid);
        } catch (exp) {
          self.removeImageIconFromMenu(null, uuid, true);
          console.log('Cannot upload this image now. Please try again later.');
        }
      }
    });
  };
  this.removeImageIconFromMenu = function(id, uuid, dontRefresh) {
    if (uuid && local_uploading[uuid]) id = local_uploading[uuid]['id'];
    if (id) {
      var ri = $('.pagescroll-images-container .image-line [alt="'+ local_uploading[uuid]['id'] +'"]')
        .closest('.pagescroll-image').find('.remove-image');
      if (dontRefresh) ri.addClass('no-reload');
      ri.trigger('click');
    }
  }
  /**
   * Предзагрузка изображения;
   * Если uuid - массив, обрабатываются все сразу
   * @param uuid
   */
  this.localUpload = function(uuid) {
    var info = [];      // array of data for each image
    var reader = [];    // FileReader for each image
    var images = [];    // Image object for each image
    var count = 0;      // overall count of images to upload
    var handled = 0;    // number of images with successfully obtained image info
    var timer, time = 0;// dont query images infinitely

    // Image loaded from disk
    var onRead = function(ind, uuid, e) {
      if (!local_uploading[uuid]) return; // the file vanished
      var URL = window.URL || window.webkitURL;

      local_uploading[uuid].status |= self.status_read;
      local_uploading[uuid].size = e.loaded || e.total;
//      local_uploading[uuid].data = e.target.result;
      local_uploading[uuid].data = (URL && typeof URL.createObjectURL === 'function') ? URL.createObjectURL(local_uploading[uuid].file) : e.target.result;
      images[ind] = new Image();
      images[ind].onload = function (e) { onParse(ind, uuid, e); }
      images[ind].onerror = function (e) {
        if (!local_uploading[uuid]) return; // the file vanished

        if ((/\.tiff$/i).test(local_uploading[uuid].file.name) || local_uploading[uuid].file.type == 'image/tiff') {
          // standard handling of tiff images
          local_uploading[uuid].tiff = true;
          local_uploading[uuid].legacy = true;
          self.uploaded_files_cnt--;
          self.legacy_make_upload(uuid);
          local_uploading[uuid].status |= self.status_parsed | self.status_queried | self.status_uploading;
        } else if (local_uploading[uuid].size > 20000000) {
          // unable to read the image locally?
          local_uploading[uuid].legacy = true;
          self.uploaded_files_cnt--;
          self.legacy_make_upload(uuid);
          local_uploading[uuid].status |= self.status_parsed | self.status_queried | self.status_uploading;
        } else {
          showMessageBox(invalidFileErrorText, invalidFileErrorHeader);
        }
      }
      images[ind].src = local_uploading[uuid].data;
    }
    // Image object loaded the image contents
    var onParse = function(ind, uuid, e) {
      if (!local_uploading[uuid]) return; // файл протух

      local_uploading[uuid].status |= self.status_parsed;
      local_uploading[uuid].width = images[ind].width;
      local_uploading[uuid].height = images[ind].height;
      handled++;
    }
    // wait for 30 seconds then attempt to cancel hanged images (this is only for opening local files)
    var onTimer = function() {
      time++;
      var done = 0;

      if (handled >= count) {
        clearInterval(timer);
        getImagesInfo();
        return;
      }

      $.each(info, function(k, v) {
        if (!v) done++;
        if (v.status & self.status_parsed) done++;
      });

      if (done >= count) {
        clearInterval(timer);
        getImagesInfo();
      } else if (time > 15) {
        if (confirm("Abort slow images?")) {
          $.each(info, function(k, v) {
            if ((v) && !(v.status & self.status_parsed)) {
              delete images[k];
              delete reader[k];
              delete local_uploading[v.uuid];
              count--;
            }
          });
          clearInterval(timer);
          getImagesInfo();
        } else {
          time = 0;
        }
      }
    }
    // ask the server to register the image and retrieve a full info about it
    var getImagesInfo = function() {
      var data = $.extend({}, {local_files: []}, getMaxThumbLimit());

      $.each(info, function(k, v) {
        if ((!v) || !(v.status & self.status_parsed) || v.status & self.status_queried) return;

        data.local_files.push({
          name: v.file.name,
          size: v.file.size,
          type: v.file.type,
          width: v.width,
          height: v.height,
          uuid: v.uuid
        });
        v.status |= self.status_queried;
      });
      if (!data.local_files.length) return;

      $.post(route_local_image, data, function (r) {
        if (r.status == 'success') {
          $.each(r.images, function(k, v) {
            var img = local_uploading[v.uuid];
            if (img) {
              var status = img.status;
              $.extend(img, v);
              img.status = status;

              if (img.status & self.status_queried) {
                self.presentNewFile(v.uuid);
              }
              if (!(img.status & self.status_uploading)) {
                self.transferLocalUpload(v.uuid);
              }
            }
          });
        } else {

        }
      }, 'json');
    }

    if (typeof uuid != 'object') {
      uuid = [uuid];
    }
    count = uuid.length;

    $.each(uuid, function (k, id) {
      self.uploaded_files_cnt++;
      info[k] = local_uploading[uuid];
      reader[k] = new FileReader();
      reader[k].onload = function(e) { onRead(k, id, e); }
      reader[k].readAsDataURL(info[k].file);
    });

    timer = setInterval(onTimer, 1000);
  }
  // add new image to constructor
  this.presentNewFile = function(uuid) {
    var n = local_uploading[uuid],
        l = $(".pagescroll-images-container"),
        objPreview;
    var j = l.find(".image-line");
    var o = j.find(".pagescroll-image").length;

    if (n.status & self.status_local) {
      $.extend(n, {
        id: n.id || '',
        src: n.data ? n.data : '//:0',
        elements: {}
      });
      if (n.ext) {
        var status = n.status;
        $.extend(n, n.ext);
        n.status = status;
      }
    }

    objPreview = j.find('[alt="'+ n.id+'"]').closest('.pagescroll-image');
    if (!objPreview.length) {
      var tmpimg = new Image();
      tmpimg.src = n.data;
      tmpimg.setAttribute('alt', n.id);
//      objPreview = $('<div class="pagescroll-image' + (o < 6 ? " first" : "") + '"><div><img alt="' + n.id + '" src="' + n.data + '"><span class="remove-image"><span>&ndash;</span></span></div><div class="upload-progress"><div class="bar"></div></div><div class="upload-complete"></div></div>');
      objPreview = $('<div class="pagescroll-image' + (o < 6 ? " first" : "") + '"><div><span class="remove-image"><span>&ndash;</span></span></div><div class="upload-progress"><div class="bar"></div></div><div class="upload-complete"></div></div>');
      objPreview.children('div').first().prepend(tmpimg);
      delete tmpimg;
      if (n.status & self.status_uploaded) {
        objPreview.removeClass('upload-in-progress').find('.upload-progress').remove();
      } else {
        objPreview.addClass('upload-in-progress');
      }
      j.append(objPreview);
      if (l.is(':visible')) {
        l.jScrollPane({});
      }
    }
    if (n.status & self.status_uploaded) {
      objPreview.find('img').data('uuid', null);
    }
    if ((n.status & self.status_local) && !(n.status & self.status_uploaded)) {
      objPreview.find('img').data('uuid', uuid);
      n.elements.preview = objPreview;
    }

    if (n.first) {
      var ext = n;
      $(".image-controls").show();
      constructorShowImageQuality(ext.quality);
      $("#size-details").html(ext.size);
      $("#const-sizes .scroll-bar-table tr").removeClass("active");
      $("#size-" + ext.size_id).addClass("active");
      constructorShowMyProduct(ext);
      $("#cropbox_container").prepend(ext.form);
      window.empty = false;
      window.thumb = ext.name;
      window.thumb_url = ext.thumb_url;
      window.pieces = ext.pieces;
      configurator.changeOrientation(ext.ratio, ext.ratio_v);
      window.allowedWidth = ext.a_width;
      window.allowedHeight = ext.a_height;
      window.megapixels = Math.round(ext.pixels / 1000) / 1000;
      window.form_array = ext.form_array;
      enableHandlers();
      isUpdateCropbox = true;
      objPreview.find('img').trigger('click');
    } else if (thumbId == n.id)  {
      if (!(n.status & self.status_uploaded)) {
        objPreview.find('img').trigger('click');
      } else {
        // Show image controls available only to uploaded images
        showAviaryButton();
      }
    }
  };

  this.legacy_make_upload = function (uuid) {
    var target = local_uploading[uuid];
    if (!target.legacy) return false;
    this.uploaded_files_cnt++;

    this.parse_file(target.file, uuid);
    if (!$("#" + this.config.file_info_selector).is(':visible')) {
      $("#html5upload").hide();
      $("#" + this.config.file_info_selector).show();
    }

    var g = new XMLHttpRequest;
    var h = this;
    var f = new FormData(document.getElementById(this.config.form_id));
    f.append("picture", target.file);

    g.upload.addEventListener("progress", function (a) {
      h.legacy_upload_progress(a, uuid)
    }, false);
    g.addEventListener("load", function (a) {
      h.legacy_upload_complete($.parseJSON(a.target.responseText), uuid);
      updateImageCounterValue(getImageCounterValue() + 1)
    }, false);
    g.addEventListener("error", function (a) {
      h.legacy_upload_failed(a, uuid)
    }, false);
    g.addEventListener("abort", function (a) {
      h.legacy_upload_failed(a, uuid)
    }, false);
    g.async = true;
    if (self.config.upload_name) {
      g.open("POST", route_legacy_upload, true, self.config.upload_name, self.config.upload_id);
    } else {
      g.open("POST", route_legacy_upload, true);
    }
    g.withCredentials = true;
    g.setRequestHeader('X_REQUESTED_WITH', 'XMLHttpRequest');
    g.send(f);
  };

  this.legacy_upload_progress = function (e, f) {
    if (e.lengthComputable) {
      var d = Math.round(e.loaded * 100 / e.total);
      if (this.config.progressbar)$("#" + this.config.file_info_selector + " .file-list-" + f).next().reportprogress(d); else $("#" + this.config.file_info_selector + " .file-list-" + f).next().html(d.toString() + "%")
    } else $("#" + this.config.file_info_selector + " .file-list-" + f).next().html("unable to compute")
  };

  this.legacy_upload_complete = function (d, uuid) {
    var target = local_uploading[uuid];
    target.status |= this.status_uploaded;
    target.data = d.image;
    this.completed_files_cnt++;
    var status = target.status;
    $.extend(target, d);
    target.status = status;
    this.presentNewFile(uuid);

    console.log('upload completed');
    this.legacy_remove_info(uuid);
    console.log(this.completed_files_cnt);
    console.log(this.uploaded_files_cnt);
    if (this.completed_files_cnt == this.uploaded_files_cnt) {
      this.onFinishUpload();
    }
  };

  this.legacy_upload_failed = function (b, uuid) {
    this.upload_failed(b, uuid);
    this.legacy_remove_info(uuid);
  };

  this.legacy_remove_info = function (uuid) {
    $("#" + this.config.file_info_selector + " .file-list-" + uuid).next().remove();
    $("#" + this.config.file_info_selector + " .file-list-" + uuid).remove();
    if (!$("#" + this.config.file_info_selector).children().length) {
      $("#" + this.config.file_info_selector).hide();
      $("#html5upload").show();
    }
  };
}
function showMessageBox(body, header) {
  if (typeof header === 'undefined') header = '&nbsp;';
  var text = customDialogText
    .split('%header%').join(header)
    .split('%message%').join(body);

  $("#dialog").html(text).dialog({resizable: false, modal: true, overlay: {opacity: 1, background: "#000000"}, width: "400", open: function () {
  }});
}
(function (c, b, a) {
  c.fn.jScrollPane = function (e) {
    function d(q, H) {
      var A, J = this, aI, ad, ay, af, aD, a0, g, au, K, P, r, al, B, ak, am, T, aE, h, aH, aw, k, j, Y, ag, x, ao, p, y, aA, u, S, f, E, ac = true, I = true, R = false, an = false, ai = q.clone(false, false).empty(), V = c.fn.mwheelIntent ? "mwheelIntent.jsp" : "mousewheel.jsp";
      S = q.css("paddingTop") + " " + q.css("paddingRight") + " " + q.css("paddingBottom") + " " + q.css("paddingLeft");
      f = (parseInt(q.css("paddingLeft"), 10) || 0) + (parseInt(q.css("paddingRight"), 10) || 0);
      function m(aP) {
        var aK, aM, aL, s, aQ, aO, aN = false,
          aJ = false;
        A = aP;
        if (aI === a) {
          aQ = q.scrollTop();
          aO = q.scrollLeft();
          q.css({overflow: "hidden", padding: 0});
          ad = q.innerWidth() + f;
          ay = q.innerHeight();
          q.width(ad);
          aI = c('<div class="jspPane" />').css("padding", S).append(q.children());
          af = c('<div class="jspContainer" />').css({width: ad + "px", height: ay + "px"}).append(aI).appendTo(q)
        } else {
          q.css("width", "");
          aN = A.stickToBottom && D();
          aJ = A.stickToRight && l();
          s = q.innerWidth() + f != ad || q.outerHeight() != ay;
          if (s) {
            ad = q.innerWidth() + f;
            ay = q.innerHeight();
            af.css({width: ad + "px", height: ay +
              "px"})
          }
          if (!s && (E == aD && aI.outerHeight() == a0)) {
            q.width(ad);
            return
          }
          E = aD;
          aI.css("width", "");
          q.width(ad);
          af.find(">.jspVerticalBar,>.jspHorizontalBar").remove().end()
        }
        aI.css("overflow", "auto");
        if (aP.contentWidth)aD = aP.contentWidth; else aD = aI[0].scrollWidth;
        a0 = aI[0].scrollHeight;
        aI.css("overflow", "");
        g = aD / ad;
        au = a0 / ay;
        K = au > 1;
        P = g > 1;
        if (!(P || K)) {
          q.removeClass("jspScrollable");
          aI.css({top: 0, width: af.width() - f});
          aq();
          t();
          aB();
          az();
          ab()
        } else {
          q.addClass("jspScrollable");
          aK = A.maintainPosition && (B || T);
          if (aK) {
            aM =
              N();
            aL = L()
          }
          Q();
          o();
          v();
          if (aK) {
            G(aJ ? aD - ad : aM, false);
            F(aN ? a0 - ay : aL, false)
          }
          C();
          Z();
          ah();
          if (A.enableKeyboardNavigation)aC();
          if (A.clickOnTrack)at();
          n();
          if (A.hijackInternalLinks)ap()
        }
        if (A.autoReinitialise && !u)u = setInterval(function () {
          m(A)
        }, A.autoReinitialiseDelay); else if (!A.autoReinitialise && u)clearInterval(u);
        aQ && (q.scrollTop(0) && F(aQ, false));
        aO && (q.scrollLeft(0) && G(aO, false));
        q.trigger("jsp-initialised", [P || K])
      }

      function Q() {
        if (K) {
          af.append(c('<div class="jspVerticalBar" />').append(c('<div class="jspCap jspCapTop" />'),
            c('<div class="jspTrack" />').append(c('<div class="jspDrag" />').append(c('<div class="jspDragTop" />'), c('<div class="jspDragBottom" />'))), c('<div class="jspCap jspCapBottom" />')));
          aE = af.find(">.jspVerticalBar");
          h = aE.find(">.jspTrack");
          r = h.find(">.jspDrag");
          if (A.showArrows) {
            j = c('<a class="jspArrow jspArrowUp" />').bind("mousedown.jsp", O(0, -1)).bind("click.jsp", M);
            Y = c('<a class="jspArrow jspArrowDown" />').bind("mousedown.jsp", O(0, 1)).bind("click.jsp", M);
            if (A.arrowScrollOnHover) {
              j.bind("mouseover.jsp",
                O(0, -1, j));
              Y.bind("mouseover.jsp", O(0, 1, Y))
            }
            ae(h, A.verticalArrowPositions, j, Y)
          }
          aw = ay;
          af.find(">.jspVerticalBar>.jspCap:visible,>.jspVerticalBar>.jspArrow").each(function () {
            aw -= c(this).outerHeight()
          });
          r.hover(function () {
            r.addClass("jspHover")
          },function () {
            r.removeClass("jspHover")
          }).bind("mousedown.jsp", function (s) {
            c("html").bind("dragstart.jsp selectstart.jsp", M);
            r.addClass("jspActive");
            var aJ = s.pageY - r.position().top;
            c("html").bind("mousemove.jsp",function (aK) {
              aF(aK.pageY - aJ, false)
            }).bind("mouseup.jsp mouseleave.jsp",
              w);
            return false
          });
          ar()
        }
      }

      function ar() {
        h.height(aw + "px");
        B = 0;
        aH = A.verticalGutter + h.outerWidth();
        aI.width(ad - aH - f);
        try {
          if (aE.position().left === 0)aI.css("margin-left", aH + "px")
        } catch (s) {
        }
      }

      function o() {
        if (P) {
          af.append(c('<div class="jspHorizontalBar" />').append(c('<div class="jspCap jspCapLeft" />'), c('<div class="jspTrack" />').append(c('<div class="jspDrag" />').append(c('<div class="jspDragLeft" />'), c('<div class="jspDragRight" />'))), c('<div class="jspCap jspCapRight" />')));
          ag = af.find(">.jspHorizontalBar");
          x = ag.find(">.jspTrack");
          ak = x.find(">.jspDrag");
          if (A.showArrows) {
            y = c('<a class="jspArrow jspArrowLeft" />').bind("mousedown.jsp", O(-1, 0)).bind("click.jsp", M);
            aA = c('<a class="jspArrow jspArrowRight" />').bind("mousedown.jsp", O(1, 0)).bind("click.jsp", M);
            if (A.arrowScrollOnHover) {
              y.bind("mouseover.jsp", O(-1, 0, y));
              aA.bind("mouseover.jsp", O(1, 0, aA))
            }
            ae(x, A.horizontalArrowPositions, y, aA)
          }
          ak.hover(function () {
            ak.addClass("jspHover")
          },function () {
            ak.removeClass("jspHover")
          }).bind("mousedown.jsp", function (s) {
            c("html").bind("dragstart.jsp selectstart.jsp",
              M);
            ak.addClass("jspActive");
            var aJ = s.pageX - ak.position().left;
            c("html").bind("mousemove.jsp",function (aK) {
              aG(aK.pageX - aJ, false)
            }).bind("mouseup.jsp mouseleave.jsp", w);
            return false
          });
          ao = af.innerWidth();
          aa()
        }
      }

      function aa() {
        af.find(">.jspHorizontalBar>.jspCap:visible,>.jspHorizontalBar>.jspArrow").each(function () {
          ao -= c(this).outerWidth()
        });
        x.width(ao + "px");
        T = 0
      }

      function v() {
        if (P && K) {
          var s = x.outerHeight(), aJ = h.outerWidth();
          aw -= s;
          c(ag).find(">.jspCap:visible,>.jspArrow").each(function () {
            ao += c(this).outerWidth()
          });
          ao -= aJ;
          ay -= aJ;
          ad -= s;
          x.parent().append(c('<div class="jspCorner" />').css("width", s + "px"));
          ar();
          aa()
        }
        if (P)aI.width(af.outerWidth() - f + "px");
        a0 = aI.outerHeight();
        au = a0 / ay;
        if (P) {
          p = Math.ceil(1 / g * ao);
          if (p > A.horizontalDragMaxWidth)p = A.horizontalDragMaxWidth; else if (p < A.horizontalDragMinWidth)p = A.horizontalDragMinWidth;
          ak.width(p + "px");
          am = ao - p;
          X(T)
        }
        if (K) {
          k = Math.ceil(1 / au * aw);
          if (k > A.verticalDragMaxHeight)k = A.verticalDragMaxHeight; else if (k < A.verticalDragMinHeight)k = A.verticalDragMinHeight;
          r.height(k + "px");
          al = aw - k;
          W(B)
        }
      }

      function ae(s, aK, aO, aL) {
        var aN = "before", aJ = "after", aM;
        if (aK == "os")aK = /Mac/.test(navigator.platform) ? "after" : "split";
        if (aK == aN)aJ = aK; else if (aK == aJ) {
          aN = aK;
          aM = aO;
          aO = aL;
          aL = aM
        }
        s[aN](aO)[aJ](aL)
      }

      function O(s, aK, aJ) {
        return function () {
          z(s, aK, this, aJ);
          this.blur();
          return false
        }
      }

      function z(aJ, s, aN, aM) {
        aN = c(aN).addClass("jspActive");
        var aK, aP, aO = true, aL = function () {
          if (aJ !== 0)J.scrollByX(aJ * A.arrowButtonSpeed);
          if (s !== 0)J.scrollByY(s * A.arrowButtonSpeed);
          aP = setTimeout(aL, aO ? A.initialDelay : A.arrowRepeatFreq);
          aO = false
        };
        aL();
        aK = aM ? "mouseout.jsp" : "mouseup.jsp";
        aM = aM || c("html");
        aM.bind(aK, function () {
          aN.removeClass("jspActive");
          aP && clearTimeout(aP);
          aP = null;
          aM.unbind(aK)
        })
      }

      function at() {
        az();
        if (K)h.bind("mousedown.jsp", function (aM) {
          if (aM.originalTarget === a || aM.originalTarget == aM.currentTarget) {
            var aJ = c(this), aN = aJ.offset(), aK = aM.pageY - aN.top - B, aP, aO = true, aL = function () {
              var aT = aJ.offset(), aQ = aM.pageY - aT.top - k / 2, aR = ay * A.scrollPagePercent, aS = al * aR / (a0 - ay);
              if (aK < 0)if (B - aS > aQ)J.scrollByY(-aR); else aF(aQ); else if (aK >
                0)if (B + aS < aQ)J.scrollByY(aR); else aF(aQ); else {
                s();
                return
              }
              aP = setTimeout(aL, aO ? A.initialDelay : A.trackClickRepeatFreq);
              aO = false
            }, s = function () {
              aP && clearTimeout(aP);
              aP = null;
              c(document).unbind("mouseup.jsp", s)
            };
            aL();
            c(document).bind("mouseup.jsp", s);
            return false
          }
        });
        if (P)x.bind("mousedown.jsp", function (aM) {
          if (aM.originalTarget === a || aM.originalTarget == aM.currentTarget) {
            var aJ = c(this), aN = aJ.offset(), aK = aM.pageX - aN.left - T, aP, aO = true, aL = function () {
              var aT = aJ.offset(), aQ = aM.pageX - aT.left - p / 2, aR = ad * A.scrollPagePercent,
                aS = am * aR / (aD - ad);
              if (aK < 0)if (T - aS > aQ)J.scrollByX(-aR); else aG(aQ); else if (aK > 0)if (T + aS < aQ)J.scrollByX(aR); else aG(aQ); else {
                s();
                return
              }
              aP = setTimeout(aL, aO ? A.initialDelay : A.trackClickRepeatFreq);
              aO = false
            }, s = function () {
              aP && clearTimeout(aP);
              aP = null;
              c(document).unbind("mouseup.jsp", s)
            };
            aL();
            c(document).bind("mouseup.jsp", s);
            return false
          }
        })
      }

      function az() {
        if (x)x.unbind("mousedown.jsp");
        if (h)h.unbind("mousedown.jsp")
      }

      function w() {
        c("html").unbind("dragstart.jsp selectstart.jsp mousemove.jsp mouseup.jsp mouseleave.jsp");
        if (r)r.removeClass("jspActive");
        if (ak)ak.removeClass("jspActive")
      }

      function aF(aJ, s) {
        if (!K)return;
        if (aJ < 0)aJ = 0; else if (aJ > al)aJ = al;
        if (s === a)s = A.animateScroll;
        if (s)J.animate(r, "top", aJ, W); else {
          r.css("top", aJ);
          W(aJ)
        }
      }

      function W(s) {
        if (s === a)s = r.position().top;
        af.scrollTop(0);
        B = s;
        var aL = B === 0, aJ = B == al, aK = s / al, aM = -aK * (a0 - ay);
        if (ac != aL || R != aJ) {
          ac = aL;
          R = aJ;
          q.trigger("jsp-arrow-change", [ac, R, I, an])
        }
        ax(aL, aJ);
        aI.css("top", aM);
        q.trigger("jsp-scroll-y", [-aM, aL, aJ]).trigger("scroll")
      }

      function aG(s, aJ) {
        if (!P)return;
        if (s < 0)s = 0; else if (s > am)s = am;
        if (aJ === a)aJ = A.animateScroll;
        if (aJ)J.animate(ak, "left", s, X); else {
          ak.css("left", s);
          X(s)
        }
      }

      function X(s) {
        if (s === a)s = ak.position().left;
        af.scrollTop(0);
        T = s;
        var aL = T === 0, aK = T == am, aJ = s / am, aM = -aJ * (aD - ad);
        if (I != aL || an != aK) {
          I = aL;
          an = aK;
          q.trigger("jsp-arrow-change", [ac, R, I, an])
        }
        av(aL, aK);
        aI.css("left", aM);
        q.trigger("jsp-scroll-x", [-aM, aL, aK]).trigger("scroll")
      }

      function ax(s, aJ) {
        if (A.showArrows) {
          j[s ? "addClass" : "removeClass"]("jspDisabled");
          Y[aJ ? "addClass" : "removeClass"]("jspDisabled")
        }
      }

      function av(s, aJ) {
        if (A.showArrows) {
          y[s ? "addClass" : "removeClass"]("jspDisabled");
          aA[aJ ? "addClass" : "removeClass"]("jspDisabled")
        }
      }

      function F(aK, s) {
        var aJ = aK / (a0 - ay);
        aF(aJ * al, s)
      }

      function G(s, aK) {
        var aJ = s / (aD - ad);
        aG(aJ * am, aK)
      }

      function U(aR, aM, aU) {
        var aJ, aV, aW, aT = 0, aQ = 0, aS, aL, aK, aO, aN, aP;
        try {
          aJ = c(aR)
        } catch (s) {
          return
        }
        aV = aJ.outerHeight();
        aW = aJ.outerWidth();
        af.scrollTop(0);
        af.scrollLeft(0);
        while (!aJ.is(".jspPane")) {
          aT += aJ.position().top;
          aQ += aJ.position().left;
          aJ = aJ.offsetParent();
          if (/^body|html$/i.test(aJ[0].nodeName))return
        }
        aS =
          L();
        aK = aS + ay;
        if (aT < aS || aM)aN = aT - A.verticalGutter; else if (aT + aV > aK)aN = aT - ay + aV + A.verticalGutter;
        if (aN)F(aN, aU);
        aL = N();
        aO = aL + ad;
        if (aQ < aL || aM)aP = aQ - A.horizontalGutter; else if (aQ + aW > aO)aP = aQ - ad + aW + A.horizontalGutter;
        if (aP)G(aP, aU)
      }

      function N() {
        return-aI.position().left
      }

      function L() {
        return-aI.position().top
      }

      function D() {
        var s = a0 - ay;
        return s > 20 && s - L() < 10
      }

      function l() {
        var s = aD - ad;
        return s > 20 && s - N() < 10
      }

      function Z() {
        af.unbind(V).bind(V, function (aL, aM, aK, s) {
          var aJ = T, aN = B;
          J.scrollBy(aK * A.mouseWheelSpeed, -s *
            A.mouseWheelSpeed, false);
          return aJ == T && aN == B
        })
      }

      function aq() {
        af.unbind(V)
      }

      function M() {
        return false
      }

      function C() {
        aI.find(":input,a").unbind("focus.jsp").bind("focus.jsp", function (s) {
          U(s.target, false)
        })
      }

      function t() {
        aI.find(":input,a").unbind("focus.jsp")
      }

      function aC() {
        var aL, s, aK = [];
        P && aK.push(ag[0]);
        K && aK.push(aE[0]);
        aI.focus(function () {
          q.focus()
        });
        q.attr("tabindex", 0).unbind("keydown.jsp keypress.jsp").bind("keydown.jsp",function (aN) {
          if (aN.target !== this && !(aK.length && c(aN.target).closest(aK).length))return;
          var aM = T, aO = B;
          switch (aN.keyCode) {
            case 40:
            case 38:
            case 34:
            case 32:
            case 33:
            case 39:
            case 37:
              aL = aN.keyCode;
              aJ();
              break;
            case 35:
              F(a0 - ay);
              aL = null;
              break;
            case 36:
              F(0);
              aL = null;
              break
          }
          s = aN.keyCode == aL && aM != T || aO != B;
          return!s
        }).bind("keypress.jsp", function (aM) {
            if (aM.keyCode == aL)aJ();
            return!s
          });
        if (A.hideFocus) {
          q.css("outline", "none");
          if ("hideFocus"in af[0])q.attr("hideFocus", true)
        } else {
          q.css("outline", "");
          if ("hideFocus"in af[0])q.attr("hideFocus", false)
        }
        function aJ() {
          var aN = T, aM = B;
          switch (aL) {
            case 40:
              J.scrollByY(A.keyboardSpeed,
                false);
              break;
            case 38:
              J.scrollByY(-A.keyboardSpeed, false);
              break;
            case 34:
            case 32:
              J.scrollByY(ay * A.scrollPagePercent, false);
              break;
            case 33:
              J.scrollByY(-ay * A.scrollPagePercent, false);
              break;
            case 39:
              J.scrollByX(A.keyboardSpeed, false);
              break;
            case 37:
              J.scrollByX(-A.keyboardSpeed, false);
              break
          }
          s = aN != T || aM != B;
          return s
        }
      }

      function aB() {
        q.attr("tabindex", "-1").removeAttr("tabindex").unbind("keydown.jsp keypress.jsp")
      }

      function n() {
        if (location.hash && location.hash.length > 1) {
          var aK, s, aJ = escape(location.hash);
          try {
            aK = c(aJ)
          } catch (aL) {
            return
          }
          if (aK.length &&
            aI.find(aJ))if (af.scrollTop() === 0)s = setInterval(function () {
            if (af.scrollTop() > 0) {
              U(aJ, true);
              c(document).scrollTop(af.position().top);
              clearInterval(s)
            }
          }, 50); else {
            U(aJ, true);
            c(document).scrollTop(af.position().top)
          }
        }
      }

      function ab() {
        c("a.jspHijack").unbind("click.jsp-hijack").removeClass("jspHijack")
      }

      function ap() {
        ab();
        c("a[href^=#]").addClass("jspHijack").bind("click.jsp-hijack", function () {
          var aJ = this.href.split("#"), s;
          if (aJ.length > 1) {
            s = aJ[1];
            if (s.length > 0 && aI.find("#" + s).length > 0) {
              U("#" + s, true);
              return false
            }
          }
        })
      }

      function ah() {
        var aJ, s, aL, aK, aM, aN = false;
        af.unbind("touchstart.jsp touchmove.jsp touchend.jsp click.jsp-touchclick").bind("touchstart.jsp",function (aO) {
          var aP = aO.originalEvent.touches[0];
          aJ = N();
          s = L();
          aL = aP.pageX;
          aK = aP.pageY;
          aM = false;
          aN = true
        }).bind("touchmove.jsp",function (aR) {
          if (!aN)return;
          var aQ = aR.originalEvent.touches[0], aP = T, aO = B;
          J.scrollTo(aJ + aL - aQ.pageX, s + aK - aQ.pageY);
          aM = aM || (Math.abs(aL - aQ.pageX) > 5 || Math.abs(aK - aQ.pageY) > 5);
          return aP == T && aO == B
        }).bind("touchend.jsp",function (aO) {
          aN = false
        }).bind("click.jsp-touchclick",
          function (aO) {
            if (aM) {
              aM = false;
              return false
            }
          })
      }

      function aj() {
        var aJ = L(), s = N();
        q.removeClass("jspScrollable").unbind(".jsp");
        q.replaceWith(ai.append(aI.children()));
        ai.scrollTop(aJ);
        ai.scrollLeft(s)
      }

      c.extend(J, {reinitialise: function (s) {
        s = c.extend({}, A, s);
        m(s)
      }, scrollToElement: function (aJ, s, aK) {
        U(aJ, s, aK)
      }, scrollTo: function (aJ, aK, s) {
        G(aJ, s);
        F(aK, s)
      }, scrollToX: function (s, aJ) {
        G(s, aJ)
      }, scrollToY: function (aJ, s) {
        F(aJ, s)
      }, scrollToPercentX: function (s, aJ) {
        G(s * (aD - ad), aJ)
      }, scrollToPercentY: function (s, aJ) {
        F(s *
          (a0 - ay), aJ)
      }, scrollBy: function (s, aK, aJ) {
        J.scrollByX(s, aJ);
        J.scrollByY(aK, aJ)
      }, scrollByX: function (aL, aJ) {
        var s = N() + Math[aL < 0 ? "floor" : "ceil"](aL), aK = s / (aD - ad);
        aG(aK * am, aJ)
      }, scrollByY: function (aL, aJ) {
        var s = L() + Math[aL < 0 ? "floor" : "ceil"](aL), aK = s / (a0 - ay);
        aF(aK * al, aJ)
      }, positionDragX: function (aJ, s) {
        aG(aJ, s)
      }, positionDragY: function (s, aJ) {
        aF(s, aJ)
      }, animate: function (s, aL, aM, aK) {
        var aJ = {};
        aJ[aL] = aM;
        s.animate(aJ, {duration: A.animateDuration, easing: A.animateEase, queue: false, step: aK})
      }, getContentPositionX: function () {
        return N()
      },
        getContentPositionY: function () {
          return L()
        }, getContentWidth: function () {
          return aD
        }, getContentHeight: function () {
          return a0
        }, getPercentScrolledX: function () {
          return N() / (aD - ad)
        }, getPercentScrolledY: function () {
          return L() / (a0 - ay)
        }, getIsScrollableH: function () {
          return P
        }, getIsScrollableV: function () {
          return K
        }, getContentPane: function () {
          return aI
        }, scrollToBottom: function (s) {
          aF(al, s)
        }, hijackInternalLinks: function () {
          ap()
        }, destroy: function () {
          aj()
        }});
      m(H)
    }

    e = c.extend({}, c.fn.jScrollPane.defaults, e);
    c.each(["mouseWheelSpeed",
      "arrowButtonSpeed", "trackClickSpeed", "keyboardSpeed"], function () {
      e[this] = e[this] || e.speed
    });
    return this.each(function () {
      var f = c(this), g = f.data("jsp");
      if (g)g.reinitialise(e); else {
        g = new d(f, e);
        f.data("jsp", g)
      }
    })
  };
  c.fn.jScrollPane.defaults = {showArrows: false, maintainPosition: true, stickToBottom: false, stickToRight: false, clickOnTrack: true, autoReinitialise: false, autoReinitialiseDelay: 500, verticalDragMinHeight: 0, verticalDragMaxHeight: 99999, horizontalDragMinWidth: 0, horizontalDragMaxWidth: 99999, contentWidth: a,
    animateScroll: false, animateDuration: 300, animateEase: "linear", hijackInternalLinks: false, verticalGutter: 4, horizontalGutter: 4, mouseWheelSpeed: 0, arrowButtonSpeed: 0, arrowRepeatFreq: 50, arrowScrollOnHover: false, trackClickSpeed: 0, trackClickRepeatFreq: 70, verticalArrowPositions: "split", horizontalArrowPositions: "split", enableKeyboardNavigation: true, hideFocus: false, keyboardSpeed: 0, initialDelay: 300, speed: 30, scrollPagePercent: 0.8}
})(jQuery, this);
(function (f) {
  var e = ["DOMMouseScroll", "mousewheel"];
  f.event.special.mousewheel = {setup: function () {
    if (this.addEventListener)for (var a = e.length; a;)this.addEventListener(e[--a], d, false); else this.onmousewheel = d
  }, teardown: function () {
    if (this.removeEventListener)for (var a = e.length; a;)this.removeEventListener(e[--a], d, false); else this.onmousewheel = null
  }};
  f.fn.extend({mousewheel: function (a) {
    return a ? this.bind("mousewheel", a) : this.trigger("mousewheel")
  }, unmousewheel: function (a) {
    return this.unbind("mousewheel",
      a)
  }});
  function d(b) {
    var l = b || window.event, m = [].slice.call(arguments, 1), a = 0, c = true, n = 0, o = 0;
    b = f.event.fix(l);
    b.type = "mousewheel";
    if (b.wheelDelta)a = b.wheelDelta / 120;
    if (b.detail)a = -b.detail / 3;
    o = a;
    if (l.axis !== undefined && l.axis === l.HORIZONTAL_AXIS) {
      o = 0;
      n = -1 * a
    }
    if (l.wheelDeltaY !== undefined)o = l.wheelDeltaY / 120;
    if (l.wheelDeltaX !== undefined)n = -1 * l.wheelDeltaX / 120;
    m.unshift(b, a, n, o);
    return f.event.handle.apply(this, m)
  }
})(jQuery);
(function (q) {
  var r = {pos: [-260, -260]}, p = 3, l = document, m = l.documentElement, o = l.body, s, k;

  function n() {
    if (this === r.elem) {
      r.pos = [-260, -260];
      r.elem = false;
      p = 3
    }
  }

  q.event.special.mwheelIntent = {setup: function () {
    var a = q(this).bind("mousewheel", q.event.special.mwheelIntent.handler);
    if (this !== l && (this !== m && this !== o))a.bind("mouseleave", n);
    a = null;
    return true
  }, teardown: function () {
    q(this).unbind("mousewheel", q.event.special.mwheelIntent.handler).unbind("mouseleave", n);
    return true
  }, handler: function (c, b) {
    var a = [c.clientX,
      c.clientY];
    if (this === r.elem || (Math.abs(r.pos[0] - a[0]) > p || Math.abs(r.pos[1] - a[1]) > p)) {
      r.elem = this;
      r.pos = a;
      p = 250;
      clearTimeout(k);
      k = setTimeout(function () {
        p = 10
      }, 200);
      clearTimeout(s);
      s = setTimeout(function () {
        p = 3
      }, 1500);
      c = q.extend({}, c, {type: "mwheelIntent"});
      return q.event.handle.apply(this, arguments)
    }
  }};
  q.fn.extend({mwheelIntent: function (a) {
    return a ? this.bind("mwheelIntent", a) : this.trigger("mwheelIntent")
  }, unmwheelIntent: function (a) {
    return this.unbind("mwheelIntent", a)
  }});
  q(function () {
    o = l.body;
    q(l).bind("mwheelIntent.mwheelIntentDefault",
      q.noop)
  })
})(jQuery);
$(document).ready(function () {
  $("body").delegate(".facebook-open-button", "click", function (b) {
    b.preventDefault();
    window.open("/facebook/", "Facebook", "menubar=1,resizable=1,width=1000,height=600,scrollbars=1")
  });
  $("body").delegate(".instagram-open-button", "click", function (b) {
    b.preventDefault();

    var domain = (document.domain.indexOf('www.') === -1) ? 'www.'+document.domain : document.domain;
    window.open("//" + domain + "/instagram/", "Instagram", "menubar=1,resizable=1,width=700,height=600,scrollbars=1")
  });
  $("body").delegate(".dropbox-open-button", "click", function (b) {
    b.preventDefault();
    window.open("/dropbox-auth-start", "Dropbox",
      "menubar=1,resizable=1,width=700,height=600,scrollbars=1")
  });
  $("body").delegate(".skydrive-open-button", "click", function (b) {
    b.preventDefault();
    window.open("/skydrive-auth-start", "Skydrive", "menubar=1,resizable=1,width=700,height=600,scrollbars=1")
  });
  $("body").delegate(".facebook-photo-open", "click", function (b) {
    b.preventDefault();
    window.close();
    if (window.opener && !window.opener.closed)window.opener.location.href = $(this).data("uri")
  });
  $("body").delegate(".instagram-photo-open", "click", function (b) {
    b.preventDefault();
    window.close();
    if (window.opener && !window.opener.closed)window.opener.location.href = $(this).data("uri")
  });
  $("body").delegate(".dropbox-photo-open", "click", function (b) {
    b.preventDefault();
    window.close();
    if (window.opener && !window.opener.closed)window.opener.location.href = $(this).data("uri")
  });
  $("body").delegate(".skydrive-photo-open", "click", function (b) {
    b.preventDefault();
    window.close();
    if (window.opener && !window.opener.closed)window.opener.location.href = $(this).data("uri")
  })
});
